<template>
  <!--页面加载动画-->
  <div class="select-box">
      <span class="defaultTxt" @click.stop="closeLayer">
        {{defaultTxt || "请选择"}}
        <i class="iconfont iconzhankai-xianxing"></i>
      </span>
      <div class="select-layer-box" v-show="showLayer">
        <div class="mask"></div>
        <div class="mainContent">
          <div class="title">{{selectData.elementName}} <span>(多选)</span></div>
          <div class="check-box">
            <div
            v-for="(item,i) in arrs"
                class="check-li"
                @click="check(i)">
              {{item.name}}
            <span :class="[{active:item.choice},'choice-icon']">
              <i class="iconfont iconduihao1"></i>
            </span>
            </div>
          </div>
          <div class="check-btns">
            <span class="check-btn btn-sure" @click="makeSure">确认</span>
            <span class="check-btn" @click="showLayer=false">取消</span>
          </div>
        </div>
      </div>
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      arrs: new Array(), //选择元素
      showLayer: false, //是否弹窗选择框
      defaultTxt: "", //是否弹窗选择框
      checkItem: new Object(), //当前滑动选择项
    };
  },
  props: ["selectData","parentItem"],
  mounted() {
    this.arrs = this.selectData.elementItems ||[];
    this.checkDefault();
  },
  methods: {
    closeLayer(){
      setTimeout(_=>{
        //按钮选择
        this.showLayer=true;
      },100)
    },
    handleCancle() {
      //munt 选择回调-取消
      this.showLayer = false;
    },
    checkDefault() {
      //检测和设置默认值
      let arr = this.arrs;
      let defaultTxt="";
      const value = this.selectData.elementValue;
      if(!value || value.length==0)return;
      value.forEach(valueItem=>{
        arr.forEach(item=>{
          if(valueItem==item.value){
            item.choice=true;
            defaultTxt+=item.name+","
          }
        })
      })
      if(defaultTxt)defaultTxt=defaultTxt.substring(defaultTxt.length-1,0);
      this.defaultTxt=defaultTxt;
      this.arrs=arr;
    },
    check(i) {
      //按钮选择
      this.arrs[i].choice=!this.arrs[i].choice;
    },
    makeSure(){
      var value=[];
      var defaultTxt="";
      this.arrs.forEach(item=>{
        if(item.choice){
          value.push(item.value)
          defaultTxt+=item.name+","
        }
      })
      if(defaultTxt)defaultTxt=defaultTxt.substring(defaultTxt.length-1,0);
      this.defaultTxt=defaultTxt;
      this.getResult(value)
      this.showLayer=false;
    },
    getResult(value) {
      //选择后回调到父组件
      this.selectData.elementValue=value;
      this.$emit("selected", {
        type:1,
        item:this.selectData,
        value: value
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.select-box {
  width: 100%;
  height: 100%;
  
}
.defaultTxt {
  width: 100%;
  height: 100%;
  line-height: 40px;
  font-size: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 50px;
  display: inline-block;
  .iconfont {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 36px;
  }
}

.select-layer-box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 1;
  }
  .mainContent {
    position: absolute;
    width: 10rem;
    left: 50%;
    bottom: 0;
    z-index: 2;
    background-color: #fff;
    transform: translateX(-50%);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .title{
      font-size: 34px;
      text-align: center;
      line-height: 2;
      padding-top: 20px;
      span{
        font-size: 28px;
      }
    }
    .check-box{
      height: 500px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
    .check-li{
      position: relative;
      padding: 20px 30px;
      line-height: 50px;
      font-size: 30px;
      color: #333;
      border-bottom: 1px solid #ececec;
      .choice-icon{
        position: absolute;
        right: 30px;
        top: 50%;
        margin-top: -22px;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: 1px solid #c8c9cc;
        text-align: center;
        line-height: 44px;
        &.active{
          background-color: #0084ff;
          border-color: #0084ff;
        }
        .iconfont{
          font-size: 28px;
          color: #fff;
        }
      }
    }
    .check-btns{
      padding: 20px 50px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      .check-btn{
        font-size: 30px;
        display: inline-block;
        padding: 0 40px;
        line-height: 70px;
        width: 250px;
        text-align: center;
        border-radius: 70px;
        border: 1px solid #999;
      }
      .btn-sure{
        border-color: #0084ff;
        color: #0084ff;
      }
    }
  }
}
</style>